module.exports = __webpack_public_path__ + "static/media/SpinningWheel.8d28f9f1.jpg";